import { ErrorCode } from '@kreart/shared';
import { makeErrorKeyResolver } from '@/lib/form/errorMessages';

export const errorKeyFor = makeErrorKeyResolver({
  [ErrorCode.PROJECT_ITEMS_NOT_FOUND]: 'projectItems.cabinets.errors.notFound',
  [ErrorCode.PROJECT_ITEMS_PROJECT_TERMINAL]: 'projectItems.cabinets.errors.projectTerminal',
  [ErrorCode.PROJECT_ITEMS_CATALOG_INCOMPATIBLE]:
    'projectItems.cabinets.errors.catalogIncompatible',
  [ErrorCode.PROJECT_ITEMS_DIMENSIONS_REQUIRED]: 'projectItems.cabinets.errors.dimensionsRequired',
  [ErrorCode.PROJECT_ITEMS_CURRENCY_MISMATCH]: 'projectItems.cabinets.errors.currencyMismatch',
  [ErrorCode.NOT_FOUND]: 'projectItems.cabinets.errors.notFound',
});
